import React, { memo } from 'react';
import { View, StyleSheet } from 'react-native';
import TouchableHighlight from 'utils/packages/TouchableHighlight';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import { SettingsItemIcon } from 'design-system/SettingsItemIcon';
import useColors from 'hooks/useColors';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { ROW_ITEM_HORIZONTAL_PADDING } from '../constants';
import { isWeb } from '../../../constants';
const WatchListItem = ({ id, name, emoji, disabled, onPressItem, RightComponent }) => {
    const colors = useColors();
    const { navigateDeprecated } = useMainStackNavigation();
    const onPress = () => {
        if (onPressItem) {
            onPressItem?.();
        }
        else {
            navigateDeprecated('InvestWatchList', { id });
        }
    };
    return (<TouchableHighlight hoverOnLight onCard={isWeb} underlayColor={colors.background.underlay} activeOpacity={1} onPress={onPress} disabled={disabled}>
      <View style={styles.container}>
        <SettingsItemIcon>
          <Text Text-20>{emoji}</Text>
        </SettingsItemIcon>
        <Spacer w={16}/>
        <View style={styles.contentContainer}>
          <Text Text-16>{name}</Text>
        </View>
        {!!RightComponent && (<>
            <Spacer w={16}/>
            {RightComponent}
          </>)}
      </View>
    </TouchableHighlight>);
};
const styles = StyleSheet.create({
    container: {
        height: rem(78),
        flexDirection: 'row',
        alignItems: 'center',
        marginHorizontal: rem(ROW_ITEM_HORIZONTAL_PADDING),
        // On web the card is padded by 8 and each row by 8, so the hover highlight sits inside the card
        ...(isWeb && { marginHorizontal: rem(8) }),
    },
    contentContainer: {
        flex: 1,
        justifyContent: 'center',
    },
});
export default memo(WatchListItem);
